/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Calendar as BigCalendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Row, Col, CardBody, Card } from "reactstrap";

import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common"; import { STYLES } from "config";

import { useLocation, useNavigate } from "react-router-dom";
import { type } from "jquery";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
const useStyles = makeStyles(() => ({
  container: {
    zIndex: "12",
    color: STYLES.PRIMARY_APP_CLR,
    alignContent: "center",
  },
}));

export default function StaffPullForwardCalender() {
  //const
  const { api } = useContext(FirebaseContext);
  const todaysDate = new Date();
  const [items, setItems] = useState({});
  const dispatch = useDispatch();

  const listingReducer = useSelector((state) => state.ListingData.listing);
  const enquiryReducer = useSelector((state) => state.enquirydata); //Use selector to get enquiry data
  const activeBranchEnquiries = useSelector(
    (state) => state.enquirydata.activeBranchEnquiries
  );

  const inactiveBranchEnquiries = useSelector(
    (state) => state.enquirydata.inactiveBranchEnquiries
  );

  const activeListings = useSelector((state) => state.ListingData.activeListingsByBranch);
  const inactiveListings = useSelector((state) => state.ListingData.inactiveListingsByBranch);

  const auth = useSelector((state) => state.auth.info); //getting state auth info
  const classes = useStyles();
  const [listings, setlistings] = useState([]);
  const [enquiries, setenquiries] = useState([]);
  const [enquiriesToDisplay, setenquiriesToDisplay] = useState([]);
  const [events, setEvents] = useState([]);
  const { MatchListingToEnquiry } = api;
  const timeToString = (time) => {
    if (time) {
      const date = new Date(time);
      return date.toISOString().split("T")[0];
    }
  };



  useEffect(() => {
    setEvents([]);
    if (enquiryReducer !== "false" && listingReducer !== "false") {
      for (let index = 0; index < activeBranchEnquiries.length; index++) {

        if (activeBranchEnquiries[index]?.pullforward?.pullforwardDate) {
          // Set title and start/end times for the event
          const title = activeBranchEnquiries[index]?.CompanyName
            ? activeBranchEnquiries[index]?.CompanyName

            : "Enquiry pull forward";

          const start = new Date(activeBranchEnquiries[index].pullforward.pullforwardDate);
          const end = start;  // Assuming the event ends at the same time as the start
          const enquiryDetails = activeBranchEnquiries[index];
          // Create the event object
          const event = { title, start, end, enquiryDetails };

          // Update the events state by adding the new event to the existing events
          setEvents((prevEvents) => [...prevEvents, event]);
        }
      }

      for (let index = 0; index < inactiveBranchEnquiries.length; index++) {  //for all
        if (inactiveBranchEnquiries[index]?.pullforward?.pullforwardDate) {
      
          // Set title and start/end times for the event
          const title = inactiveBranchEnquiries[index]?.CompanyName 
            ? (`Enquiry - ${inactiveBranchEnquiries[index]?.CompanyName}`) 
            : "Enquiry pull forward";
      
          const start = new Date(inactiveBranchEnquiries[index].pullforward.pullforwardDate);
          const end = start;  // Assuming the event ends at the same time as the start
          const enquiryDetails = inactiveBranchEnquiries[index];

          // Create the event object
          const event = { title, start, end, enquiryDetails };

          // Update the events state by adding the new event to the existing events
          setEvents((prevEvents) => [...prevEvents, event]);
        }
      }

      for (let index = 0; index < activeListings.length; index++) {
        if (activeListings[index]?.pullforward?.pullforwardDate) {

          // Set title and start/end times for the event
          const title = activeListings[index]?.seller?.company
            ? `Listing - ${activeListings[index]?.seller?.company}`
            : "Listing pull forward";

          const start = new Date(activeListings[index].pullforward.pullforwardDate);
          const end = start;  // Assuming the event ends at the same time as the start
          const enquiryDetails = { ...activeBranchEnquiries[index], objectType: 'Listing' };

          // Create the event object
          const event = { title, start, end, enquiryDetails };

          // Update the events state by adding the new event to the existing events
          setEvents((prevEvents) => [...prevEvents, event]);
        }
      }

      for (let index = 0; index < inactiveListings.length; index++) {
        if (inactiveListings[index]?.pullforward?.pullforwardDate) {

          // Set title and start/end times for the event
          const title = inactiveListings[index]?.seller?.company
            ? `Listing - ${inactiveListings[index]?.seller?.company}`
            : "Listing pull forward";

          const start = new Date(inactiveListings[index].pullforward.pullforwardDate);
          const end = start;  // Assuming the event ends at the same time as the start
          const enquiryDetails = { ...inactiveListings[index], objectType: 'Listing' };

          // Create the event object
          const event = { title, start, end, enquiryDetails };

          // Update the events state by adding the new event to the existing events
          setEvents((prevEvents) => [...prevEvents, event]);
        }
      }
    }

  }, [enquiryReducer, listingReducer]);

  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <BigCalendar
                selectable
                localizer={localizer}
                events={events}
                // step={15}
                // timeslots={1}
                startAccessor="start"
                endAccessor="end"
                style={{ margin: "50px", color: "#000000" }}
                // defaultView="week"
                scrollToTime={new Date()}
                defaultDate={new Date()}
                onSelectEvent={(event) => {
                  {
                    event?.enquiryDetails?.objectType !== null ? (
                      navigate("/stockdetials", { state: { item: event.enquiryDetails } })
                    ) :
                      navigate("/staffenquirydetails", { state: { item: event.enquiryDetails } });
                  }

                }}
              // eventPropGetter={eventColors}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
